module.exports = __webpack_public_path__ + "static/phone-d21cd3e78184ee5e9d6500ea2459c482.png";